import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function SeoSchema() {
  const location = useLocation();
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://haruka-fitness.com';

  useEffect(() => {
    // Remove existing schema script
    const existingScript = document.querySelector('script[data-schema="true"]');
    if (existingScript) {
      existingScript.remove();
    }

    let schemaData: any = null;

    // Home page schema
    if (location.pathname === '/') {
      schemaData = {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "HealthAndBeautyBusiness",
            "@id": `${siteUrl}/#organization`,
            "name": "ハルカフィットネス",
            "description": "東京都立川市の30代以上の女性専門パーソナルトレーニングジム",
            "url": siteUrl,
            "logo": `${siteUrl}/logo.png`,
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "立川市",
              "addressRegion": "東京都",
              "addressCountry": "JP"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "35.714258",
              "longitude": "139.413642"
            },
            "priceRange": "$$",
            "sameAs": [
              "https://www.instagram.com/haruka_fitness"
            ]
          },
          {
            "@type": "WebSite",
            "@id": `${siteUrl}/#website`,
            "url": siteUrl,
            "name": "ハルカフィットネス",
            "description": "東京都立川市の30代以上の女性専門パーソナルトレーニング",
            "publisher": {
              "@id": `${siteUrl}/#organization`
            }
          },
          {
            "@type": "WebPage",
            "@id": `${siteUrl}/#webpage`,
            "url": siteUrl,
            "name": "東京都立川市 パーソナルトレーニング 女性専門 ハルカフィットネス",
            "isPartOf": {
              "@id": `${siteUrl}/#website`
            },
            "about": {
              "@id": `${siteUrl}/#organization`
            },
            "description": "東京都立川市の30代以上の女性専門パーソナルトレーニング「ハルカフィットネス」。痩せにくくなった、ジム通いが続かないとお悩みの方へ。LINEで気軽に相談できる食事管理とトレーニング指導で、あなたらしい美しさを実現します。"
          }
        ]
      };
    }
    // Privacy policy page schema
    else if (location.pathname === '/privacy-policy') {
      schemaData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": `${siteUrl}/privacy-policy#webpage`,
        "url": `${siteUrl}/privacy-policy`,
        "name": "プライバシーポリシー - ハルカフィットネス",
        "description": "ハルカフィットネスのプライバシーポリシー。個人情報の取り扱いについて説明しています。",
        "isPartOf": {
          "@id": `${siteUrl}/#website`
        }
      };
    }

    // Add schema script if data exists
    if (schemaData) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'true');
      script.textContent = JSON.stringify(schemaData);
      document.head.appendChild(script);
    }

    // Cleanup function
    return () => {
      const script = document.querySelector('script[data-schema="true"]');
      if (script) {
        script.remove();
      }
    };
  }, [location.pathname, siteUrl]);

  return null;
}
